export var props = {
  label: {},
  value: {}
};